"use strict";

var _defineProperty = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCompareFunctionArbitrary = void 0;

var TextEscaper_1 = require("../helpers/TextEscaper");

var symbols_1 = require("../../../check/symbols");

var hash_1 = require("../../../utils/hash");

var stringify_1 = require("../../../utils/stringify");

var integer_1 = require("../../integer");

var tuple_1 = require("../../tuple");

function buildCompareFunctionArbitrary(cmp) {
  return (0, tuple_1.tuple)((0, integer_1.integer)().noShrink(), (0, integer_1.integer)(1, 0xffffffff).noShrink()).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        seed = _ref2[0],
        hashEnvSize = _ref2[1];

    var producer = function producer() {
      var recorded = {};

      var f = function f(a, b) {
        var reprA = (0, stringify_1.stringify)(a);
        var reprB = (0, stringify_1.stringify)(b);
        var hA = (0, hash_1.hash)("".concat(seed).concat(reprA)) % hashEnvSize;
        var hB = (0, hash_1.hash)("".concat(seed).concat(reprB)) % hashEnvSize;
        var val = cmp(hA, hB);
        recorded["[".concat(reprA, ",").concat(reprB, "]")] = val;
        return val;
      };

      return Object.assign(f, _defineProperty({
        toString: function toString() {
          var seenValues = Object.keys(recorded).sort().map(function (k) {
            return "".concat(k, " => ").concat((0, stringify_1.stringify)(recorded[k]));
          }).map(function (line) {
            return "/* ".concat((0, TextEscaper_1.escapeForMultilineComments)(line), " */");
          });
          return "function(a, b) {\n  // With hash and stringify coming from fast-check".concat(seenValues.length !== 0 ? "\n  ".concat(seenValues.join('\n  ')) : '', "\n  const cmp = ").concat(cmp, ";\n  const hA = hash('").concat(seed, "' + stringify(a)) % ").concat(hashEnvSize, ";\n  const hB = hash('").concat(seed, "' + stringify(b)) % ").concat(hashEnvSize, ";\n  return cmp(hA, hB);\n}");
        }
      }, symbols_1.cloneMethod, producer));
    };

    return producer();
  });
}

exports.buildCompareFunctionArbitrary = buildCompareFunctionArbitrary;